const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  uid: state => state.user.id,
  super_manager: state => state.user.super_manager,
  dimension_type: state => state.user.dimension_type,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  mobile: state => state.user.mobile,
  merge_dimension: state => state.user.merge_dimension,
  account: state => state.user.account,
  level: state => state.user.level,
  rank_id: state => state.user.rank_id,
  platform_id: state => state.user.platform_id,
  loginInfoDialog: state => state.user.loginInfoDialog,
  department_id: state => state.user.department_id,
  department_group_id: state => state.user.department_group_id,
  department_group_position_id: state => state.user.department_group_position_id,
  department_group_position_worker_id: state => state.user.department_group_position_worker_id,
  department_six_id: state => state.user.department_six_id,
  department_seven_id: state => state.user.department_seven_id,
  department_eight_id: state => state.user.department_eight_id,
  platform_name: state => state.user.platform_name,
  department_name: state => state.user.department_name,
  department_group_name: state => state.user.department_group_name,
  department_group_position_name: state => state.user.department_group_position_name,
  department_group_position_worker_name: state => state.user.department_group_position_worker_name,
  department_six_name: state => state.user.department_six_name,
  department_seven_name: state => state.user.department_seven_name,
  department_eight_name: state => state.user.department_eight_name,
  leader: state => state.user.leader,
  type: state => state.user.type,
  user_message: state => state.user.user_message,
  banners: state => state.user.banners,
  platform_map: state => state.user.platform_map,
  plat_map: state => state.user.plat_map,
  permission_routes: state => state.permission.routes,
  permission_routesType: state => state.permission.routesType,
  last_permission_routesType: state => state.permission.lastRoutesType,
  permission_uri: state => state.permission.permissionUri,
  permission_module: state => state.permission.permissionModule,
  permission_all: state => state.permission.permissionAll,
  ws_message: state => state.websocket.message,
  timer: state => state.timer.timer,
  timerObject: state => state.timer.timerObject,
  miniDialogAPK: state => state.sdk.miniDialogAPK,
  tooltipAttributes: state => state.sdk.tooltipAttributes,
  xiGuaPlayer: state => state.xiGuaPlayer,
  requestId: state => state.app.requestId,
  fullScreenType: state => state.app.fullScreenType
}
export default getters
